import { timeline } from "../../data/content";
import { Reveal, SectionHeading } from "./Reveal";

export const Timeline = () => (
  <section
    id="timeline"
    data-testid="timeline-section"
    className="relative border-t border-[var(--border-subtle)] bg-surface"
  >
    <div className="max-w-6xl mx-auto px-6 md:px-12 py-24 md:py-32">
      <SectionHeading
        index="06"
        overline="Path"
        title="How I got here."
        description="A short line from university to leading backend engineering."
      />

      <div className="relative max-w-3xl">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-[var(--border-subtle)]" />
        <div className="space-y-10">
          {timeline.map((t, i) => (
            <Reveal key={t.title} delay={i * 0.06}>
              <div
                data-testid={`timeline-item-${i}`}
                className="relative pl-10"
              >
                <span className="absolute left-0 top-1.5 h-[15px] w-[15px] rounded-full border-2 border-[var(--bg-surface)] bg-[var(--text-tertiary)] ring-1 ring-[var(--border-strong)]" />
                <p className="font-mono-tech text-xs tracking-widest text-tertiary-c">
                  {t.year}
                </p>
                <h3 className="mt-1.5 font-heading font-bold text-lg md:text-xl tracking-tight text-primary-c">
                  {t.title}
                </h3>
                <p className="mt-0.5 text-sm text-secondary-c">{t.subtitle}</p>
                <p className="mt-2 text-sm text-tertiary-c leading-relaxed">
                  {t.detail}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
